import { combineReducers } from "@reduxjs/toolkit";
import { contactsPageSlice } from "@/pages/ContactsPage/slice";
import { themeSlice } from "@/services/theme/slice";
import { authSlice } from "@/services/auth/slice";
import { dashboardsPageReducers } from "@/pages/DashboardsPage/slice";
import { notesManagerSlice, notesManagerTableSlice } from "@/features/NotesManager/model";
import { calendarSlice } from "@/features/calendar/model";
import { signUpSlice } from "@/features/sign-up";
import { connectionsTableSlice } from "@/features/ConnectionsTable";
import { mobileNoteEditorSlice } from "@/common/NotesTable/model/mobile-note-editor-slice";
import { vcfSlice } from "@/entities/vcf";
import { paymentSlice } from "@/features/payment-form";
import { passwordRecoverySlice } from "@/features/password-recovery";
import { notesContentReducer } from "@/pages/NotesPage";
import { ideasPageReducer } from "@/pages/IdeasPage";
import { commitmentsPageReducer } from "@/pages/CommitmentsPage";
import { contactNotesReducer } from "@/pages/ContactsPage/Tabs/notes-tab/model";
import { contactCommitmentsReducer } from "@/pages/ContactsPage/Tabs/commitments-tab/model";
import { contactIdeasReducer } from "@/pages/ContactsPage/Tabs/ideas-tab/model";
import { contactsReducer } from "@/features/contacts/model";
import { contactsTabsReducer } from "@/entities/contacts-tabs";
import { rootApi } from "../api/api";
import { i18nSlice } from "../i18n/slice/state";
import { blockingModalSlice } from "../blocking-modal";

export const rootReducer = combineReducers({
  [rootApi.reducerPath]: rootApi.reducer,
  [contactsPageSlice.reducerPath]: contactsPageSlice.reducer,
  [themeSlice.reducerPath]: themeSlice.reducer,
  [authSlice.reducerPath]: authSlice.reducer,
  [notesManagerTableSlice.reducerPath]: notesManagerTableSlice.reducer,
  [mobileNoteEditorSlice.reducerPath]: mobileNoteEditorSlice.reducer,
  [notesManagerSlice.reducerPath]: notesManagerSlice.reducer,
  [calendarSlice.reducerPath]: calendarSlice.reducer,
  [i18nSlice.reducerPath]: i18nSlice.reducer,
  [signUpSlice.reducerPath]: signUpSlice.reducer,
  [connectionsTableSlice.reducerPath]: connectionsTableSlice.reducer,
  [paymentSlice.reducerPath]: paymentSlice.reducer,
  [vcfSlice.reducerPath]: vcfSlice.reducer,
  [blockingModalSlice.reducerPath]: blockingModalSlice.reducer,
  [passwordRecoverySlice.reducerPath]: passwordRecoverySlice.reducer,
  contacts: contactsReducer,
  contactsTabs: contactsTabsReducer,
  notesContent: notesContentReducer,
  ideasPage: ideasPageReducer,
  commitmentsPage: commitmentsPageReducer,
  contactNotes: contactNotesReducer,
  contactCommitments: contactCommitmentsReducer,
  contactIdeas: contactIdeasReducer,
  ...dashboardsPageReducers,
});
